import { render, staticRenderFns } from "./historicalRental.vue?vue&type=template&id=326221b8&scoped=true"
import script from "./historicalRental.vue?vue&type=script&lang=js"
export * from "./historicalRental.vue?vue&type=script&lang=js"
import style0 from "./historicalRental.vue?vue&type=style&index=0&id=326221b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326221b8",
  null
  
)

export default component.exports